import fp from 'lodash/fp'
import { observable, computed, action } from 'mobx'
import { spec, isValid, isInvalid, validateAll } from 'utils/validation'

import ValidatedFieldModel from './validated-field.model'

class VadlidationFormModel {
  id = null

  fields = null

  fieldsSpec = null

  @observable submission = false

  constructor(id, fields, fieldsSpec) {
    this.id = id

    this.fields = fields
    this.fieldsSpec = spec.of(fieldsSpec)

    fp.invokeArgsMap('setFormRef', [this], this.fields)
  }

  static create(id, fields, fieldsSpec) {
    return new VadlidationFormModel(id, fields, fieldsSpec)
  }

  static createFieldByDescriptor(fieldName, descriptor) {
    let initialValue
    let readonly = false
    let name = fieldName
    let spec = descriptor

    if (!fp.isFunction(descriptor)) {
      initialValue = descriptor.initialValue
      readonly = descriptor.readonly
      spec = descriptor.spec
      name = descriptor.alias || fieldName
    }

    return ValidatedFieldModel.create(name, initialValue, spec, readonly)
  }

  static fromDescription(id, description) {
    const fields = {}
    const fieldsSpec = {}

    for (const [fieldName, descriptor] of fp.entries(description)) {
      const field = VadlidationFormModel.createFieldByDescriptor(
        fieldName,
        descriptor
      )
      fields[fieldName] = field
      fieldsSpec[fieldName] = field.spec
    }

    return VadlidationFormModel.create(id, fields, fieldsSpec)
  }

  getControl(name) {
    const control = this.fields[name]

    if (!control) {
      throw new Error(`${name} control is not defined`)
    }

    return control
  }

  getFieldsValue = fp.flow(
    fp.entries,
    fp.map(([key, item]) => [key, item.pureValue]),
    fp.fromPairs
  )

  @computed
  get isInvalid() {
    return isInvalid(this.fieldsSpec, this.value)
  }

  @computed
  get isValid() {
    return isValid(this.fieldsSpec, this.value)
  }

  @computed
  get value() {
    return this.getFieldsValue(this.fields)
  }

  @computed
  get error() {
    return validateAll(this.fieldsSpec, this.value)
  }

  @action
  setSubmission(submission) {
    this.submission = submission
  }

  setTouched(value) {
    fp.invokeArgsMap('setTouched', [value], this.fields)
  }

  refreshInitialValues() {
    fp.invokeMap('refreshInitialValue', this.fields)
  }

  reset() {
    fp.invokeMap('reset', this.fields)
  }
}

export default VadlidationFormModel
